module.exports = __webpack_public_path__ + "media/09 ethnic.f2cb3ee1.mp3";